import { ObjectValues } from 'types';

export const INDUSTRY = {
  AEROSPACE_AND_DEFENCE: 'Aerospace and Defense',
  AIR_FLIGHT_AND_LOGISTICS: 'Air Freight And Logistics',
  AIRLINES: 'Airlines',
  AUTO_COMPONENTS: 'Auto Components',
  AUTOMOBILES: 'Automobiles',
  BANKS: 'Banks',
  BEVERAGES: 'Beverages',
  BIOTECHNOLOGY: 'Biotechnology',
  BUILDING_PRODUCTS: 'Building Products',
  CAPITAL_MARKETS: 'Capital Markets',
  CHEMICALS: 'Chemicals',
  COMMERCIAL_SERVICES_AND_SUPPLIES: 'Commercial Services And Supplies',
  COMMUNICATIONS: 'Communications',
  COMMUNICATIONS_EQUIPMENT: 'Communications Equipment',
  CONSTRUCTION: 'Construction, Containers And Packaging',
  DISTRIBUTORS: 'Distributors',
  DIVERSIFIED_CONSUMER_SERVICES: 'Diversified Consumer Services',
  DIVERSIFIED_TELECOMMUNICATION_SERVICES:
    'Diversified Telecommunication Services',
  ELECTRICAL_EQUIPMENT: 'Electrical Equipment',
  ELECTRONIC_EQUIPMENT_INSTRUMENTS_AND_COMPONENTS:
    'Electronic Equipment, Instruments And Components',
  INSTRUMENTS_AND_COMPONENTS: 'Instruments And Components',
  ENERGY_EQUIPMENT_AND_SERVICES: 'Energy Equipment And Services',
  EQUITY_REAL_ESTATE_INVESTMENT_TRUSTS:
    'Equity Real Estate Investment Trusts (REITs)',
  FINANCE_INSURANCE_AND_REAL_ESTATE: 'Finance Insurance And Real Estate',
  FOOD_PRODUCTS: 'Food Products',
  HEALTH_CARE_EQUIPMENT_AND_SUPPLIES: 'Health Care Equipment And Supplies',
  HEALTH_CARE_PROVIDERS_AND_SERVICES: 'Health Care Providers And Services',
  HEALTH_CARE_TECHNOLOGY: 'Health Care Technology',
  HOTELS_RESTAURANTS_AND_LEISURE: 'Hotels, Restaurants And Leisure',
  HOUSEHOLD_DURABLES: 'Household Durables',
  HOUSEHOLD_PRODUCTS: 'Household Products',
  INDEPENDENT_POWER_AND_RENEWABLE_ELECTRICTY_PRODUCERS:
    'Independent Power And Renewable Electricity Producers',
  INDUSTRIAL_CONGLOMERATES: 'Industrial Conglomerates',
  INSURANCE: 'Insurance',
  INTERNET_SOFTWARE_AND_SERVICES: 'Internet Software And Services',
  IT_SERVICES: 'IT Services',
  LEISURE_PRODUCTS: 'Leisure Products',
  LIFE_SCIENCES_TOOLS_AND_SERVICES: 'Life Sciences Tools And Services',
  MACHINERY: 'Machinery',
  MANUFACTURING: 'Manufacturing',
  MARINE: 'Marine',
  MARKETING_ADVERTISING_SALES: 'Marketing Advertising Sales',
  MEDIA: 'Media',
  MINING: 'Mining',
  MORTGAGE_REAL_INVESTMENT_TRUSTS:
    'Mortgage Real Estate Investment Trusts (REITs)',
  OIL: 'Oil',
  GAS_AND_CONSUMABLE_FUELS: 'Gas And Consumable Fuels',
  ONLINE_RECRUITMENT_AND_TRAINING: 'Online Recruitment and Training',
  PAPER_ADN_FOREST_PRODUCTS: 'Paper And Forest Products',
  PERSONAL_PRODUCTS: 'Personal Products',
  PHARMACEUTICALS: 'Pharmaceuticals',
  PROFESSIONAL_SERVICES: 'Professional Services',
  REAL_ESTATE_MANAGEMENT_AND_DEVELOPMENT:
    'Real Estate Management And Development',
  RETAIL_TRADE: 'Retail Trade',
  ROAD_AND_SAIL: 'Road And Rail',
  SEMICONDUCTORS_AND_SEMICONDUCTOR_EQUIPMENT:
    'Semiconductors And Semiconductor Equipment',
  SERVICES: 'Services',
  SOFTWARE: 'Software',
  TECHNOLOGY_HARDWARE_STORAGE_AND_PERIPHERALS:
    'Technology Hardware, Storage And Peripherals',
  TEXTILES_APPAREL_AND_LUXURY_GOODS: 'Textiles, Apparel And Luxury Goods',
  TOBACCO: 'Tobacco',
  TRADING_COMPANIES_AND_DISTRIBUTIONS: 'Trading Companies And Distributors',
  TRANSPORT: 'Transport',
  TRANSPORTATION_INFRASTRUCTURE: 'Transportation Infrastructure',
  UTILITIES: 'Utilities',
  WHOLESALE_TRADE: 'Wholesale Trade',
  WIRELESS_TELECOMMUNICATION_SERVICE: 'Wireless Telecommunication Services',
  OTHER: 'Other',
} as const;

export type Industry = ObjectValues<typeof INDUSTRY>;
